import {Component, OnInit, ViewChild} from '@angular/core';
import {CodemirrorComponent} from '@ctrl/ngx-codemirror';
import {FormControl, FormGroup} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {SharedService} from '../../../services/shared.service';
import {environment} from '../../../../environments/environment';
import {MatDialogRef} from '@angular/material/dialog';
import {ToastService} from '../../../services/toast.service';
import {GridService} from '../../../services/grid.service';

@Component({
  selector: 'app-expressions-builder-dialog',
  templateUrl: './expressions-builder-dialog.component.html',
  styleUrls: ['./expressions-builder-dialog.component.scss']
})
export class ExpressionsBuilderDialogComponent implements OnInit {
  @ViewChild('codeMirror') private codeEditorCmp?: CodemirrorComponent;
  public rows: any[] = ["id","sku","notes","shopify_published","obsolete","handle","amazon_published","replacement_sku","shipping_tag","brand_id","type_id","description","list_price","cost_price","sell_price","pack_qty","image","datasheet", 'datasheet_new',"installation_instructions","url_manufacturer","body_seo","google_category","weight_lbs","title_prefix_1","title_prefix_2","title_prefix_3","title_suffix_1","title_suffix_2","title_suffix_3","body_prefix_1","body_prefix_2","body_prefix_3","body_suffix_1","body_suffix_2","body_suffix_3","product_tags","brand","type"];
  public dynamicRows = ['img_alt', 'body', 'variant_grams', 'seo_title', 'title', 'weight', 'obsolete_html', 'sku_replacement_url', 'mws_sku_replacement_url', 'bhs_url', 'datasheet_html', 'installation_instructions_html', 'url_manufacturer_html', 'pack_text'];
  public dynamicField = [
    {
      title: 'MWS Sell Price',
      value: 'mws_sell_price'
    },
    {
      title: 'MWS SKU Replacement URL',
      value: 'mws_sku_replacement_url'
    },
    {
      title: 'ASM Invalid Ship Methods',
      value: 'asm_invalid_ship_methods'
    },
    {
      title: 'Image Alt Text',
      value: 'img_alt'
    },
    {
      title: 'Body (HTML)',
      value: 'body'
    },
    {
      title: 'SEO Title',
      value: 'seo_title'
    },
    {
      title: 'Title',
      value: 'title'
    },
    {
      title: 'GMC Title',
      value: 'gmc_title'
    },
    {
      title: 'Weight',
      value: 'weight'
    },
    {
      title: 'Obsolete HTML',
      value: 'obsolete_html'
    },
    {
      title: 'SKU Replacement URL',
      value: 'sku_replacement_url'
    },
    {
      title: 'BHS URL',
      value: 'bhs_url'
    },
    {
      title: 'Datasheet HTML',
      value: 'datasheet_html'
    },
    {
      title: 'Installation Instructions HTML',
      value: 'installation_instructions_html'
    },
    {
      title: 'URL Manufacturer HTML',
      value: 'url_manufacturer_html'
    },
    {
      title: 'Pack Text',
      value: 'pack_text'
    }
  ];
  public codemirrorContent: string = ' ';
  public codemirrorConfig: any = {
    mode: "javascript",
    lineNumbers: true,
  }
  public lineNumber: number = 0;
  public charNumber: number = 0;
  public staticField = '';


  form = new FormGroup({
    type: new FormControl(this.rows[0]),
    dynamic_field_rule: new FormControl('body'),
    dynamic_field: new FormControl('img_alt'),
  });

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private dialogRef: MatDialogRef<ExpressionsBuilderDialogComponent>,
    private toastService: ToastService,
    private gridService: GridService,
  ) { }

  ngOnInit(): void {
    this.loadRule();
    this.form.patchValue({
      type: null,
      dynamic_field: null
    })
  }

  cursorActivity($event: any): void {
    this.lineNumber = this.codeEditorCmp?.codeMirror?.getCursor().line || 0;
    this.charNumber = this.codeEditorCmp?.codeMirror?.getCursor().ch || 0;
    console.log('cursorActivity', this.lineNumber, this.charNumber);
  }

  setEditorContent(event: any) {
    this.restoreTags();
    this.restoreDynamicTags();
  }

  onChange($event: any): void {
    console.log('onChange', this.staticField);
    const selectValue  = this.form.get('type')?.value;
    let snippet = `[[field-data-${selectValue}]]`;
    this.codeEditorCmp?.codeMirror?.getDoc().replaceRange(snippet, {line: this.lineNumber, ch: this.charNumber});
    let htmlNode = document.createElement("span");
    htmlNode.textContent = selectValue;
    htmlNode.classList.add('action-btn');
    htmlNode.setAttribute('contenteditable', 'false');
    this.codeEditorCmp?.codeMirror?.getDoc().markText({line: this.lineNumber, ch: this.charNumber - snippet.length }, {line: this.lineNumber,ch: this.charNumber}, {
      readOnly: false,
      replacedWith: htmlNode
    });
    this.form.patchValue({
      type: null
    });
  }

  onChangeDynamicField($event: any): void {
    console.log('---', $event);
    const selectValue  = this.form.get('dynamic_field')?.value;
    let snippet = `[[dynamic-data-${selectValue}]]`;
    this.codeEditorCmp?.codeMirror?.getDoc().replaceRange(snippet, {line: this.lineNumber, ch: this.charNumber});
    let htmlNode = document.createElement("span");
    if (typeof selectValue === "string") {
      htmlNode.textContent = selectValue;
    }
    htmlNode.classList.add('action-btn');
    htmlNode.setAttribute('contenteditable', 'false');
    this.codeEditorCmp?.codeMirror?.getDoc().markText({line: this.lineNumber, ch: this.charNumber - snippet.length }, {line: this.lineNumber,ch: this.charNumber}, {
      readOnly: false,
      replacedWith: htmlNode
    });
    this.form.patchValue({
      dynamic_field: null
    });
  }

  loadRule(): void {
    this.http.get(environment.API_PATH + `/feed/rule/${this.form.get('dynamic_field_rule')?.value}`).subscribe((res: any) => {
      if (res) {
        this.codeEditorCmp?.codeMirror?.setValue(res.rule);
        this.restoreTags();
        this.restoreDynamicTags();
      }
    });
  }

  saveRule(): void {
    this.http.post(environment.API_PATH + '/feed/rule', {
      name: this.form.get('dynamic_field_rule')?.value,
      rule: this.codeEditorCmp?.codeMirror?.getValue()
    }).subscribe(res => {
      // console.log(res);
      this.toastService.success('Formula updated successfully!');
      // this.dialogRef.close();
      this.gridService.gridApi?.refreshServerSide();
    });
  }

  restoreDynamicTags(): void {
    const indexes: any = [];
    let text = this.codeEditorCmp?.codeMirror?.getValue() || '';
    this.dynamicRows.forEach(row => {
      let snippet: any = `\\[\\[dynamic-data-${row}\\]\\]`;
      const regEx = new RegExp(snippet, 'gi');
      const i = [...text.matchAll(regEx)];
      let finder: number = text?.indexOf(snippet.replaceAll('\\', ''));
      if (finder !== -1) {
        indexes.push({
          index: i.map(x => x.index),
          snippet: snippet.replaceAll('\\', ''),
          row
        })
      }
    });

    indexes.forEach((item: any) => {
      item.index.forEach((i: any) => {
        let htmlNode = document.createElement("span");
        htmlNode.textContent = item.row;
        htmlNode.classList.add('action-btn');
        htmlNode.setAttribute('contenteditable', 'false');
        this.codeEditorCmp?.codeMirror?.getDoc().markText({line: 0, ch: i}, {line: 0, ch: i + item.snippet.length}, {
          readOnly: false,
          replacedWith: htmlNode
        });
      });
    });
    console.log('indexes', indexes);
  }

  restoreTags(): void {
    const indexes: any = [];
    let text = this.codeEditorCmp?.codeMirror?.getValue() || '';
    this.rows.forEach(row => {
      let snippet: any = `\\[\\[field-data-${row}\\]\\]`;
      const regEx = new RegExp(snippet, 'gi');
      const i = [...text.matchAll(regEx)];
      let finder: number = text?.indexOf(snippet.replaceAll('\\', ''));
      if (finder !== -1) {
        indexes.push({
          index: i.map(x => x.index),
          snippet: snippet.replaceAll('\\', ''),
          row
        })
      }
    });

    indexes.forEach((item: any) => {
      item.index.forEach((i: any) => {
        let htmlNode = document.createElement("span");
        htmlNode.textContent = item.row;
        htmlNode.classList.add('action-btn');
        htmlNode.setAttribute('contenteditable', 'false');
        this.codeEditorCmp?.codeMirror?.getDoc().markText({line: 0, ch: i}, {line: 0, ch: i + item.snippet.length}, {
          readOnly: false,
          replacedWith: htmlNode
        });
      });
    });
    console.log('indexes', indexes);
  }
}
